import { UploadedMediaRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const uploadMedia: (
  fetchContext: FetchContext,
  questionnaireId: number, 
  mediaContent: File,
  accessToken?: string,
) => Promise<UploadedMediaRef> = (fetchContext, questionnaireId, mediaContent, accessToken) => {
  const formData = new FormData();
  formData.append('mediaUploadRequest', mediaContent);

  return fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}/media`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: formData,
  }).then((response) => responseErrorHandler<UploadedMediaRef>(fetchContext.errorStore, response, 'upload media'));
};
